import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import classes from "./AppContainer.module.scss";

const AppContainer = ({ children }) => {
    const location = useLocation();

    // Force hide TabsContainer on chat-human page via global CSS
    useEffect(() => {
        if (location.pathname.includes('/chat-human')) {
            document.body.setAttribute('data-route', 'chat-human');
        } else {
            document.body.removeAttribute('data-route');
        }
    }, [location.pathname]);

    return (
        <div className={classes.container}>
            {children}
        </div>
    );
};

export default AppContainer;
